import type { Day, DayData, TimeSlot, CookingTimeTranslations } from './types';
import { TimeSlotBar } from './TimeSlotBar';

interface DaySectionProps {
  day: Day;
  dayData: DayData;
  isCurrentDay: boolean;
  t: CookingTimeTranslations;
}

export function DaySection({ day, dayData, isCurrentDay, t }: DaySectionProps) {
  const timeSlots: TimeSlot[] = ['morning', 'afternoon', 'evening', 'lateNight'];

  return (
    <div
      className={`p-6 rounded-[5px] border border-border ${
        isCurrentDay
          ? 'bg-muted'
          : 'bg-background'
      }`}
    >
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-[clamp(13px,3.2vw,15px)] text-foreground">
          {t.days[day]}
        </h3>
      </div>

      <div className="grid gap-4">
        {timeSlots.map((timeSlot) => (
          <TimeSlotBar
            key={timeSlot}
            timeSlot={timeSlot}
            data={dayData[timeSlot]}
            t={t}
          />
        ))}
      </div>
    </div>
  );
}
